import React from 'react';
import "./styles.css";
import CustomModal, { CustomModalContent, CustomModalFooter, ModalPrimaryButton } from '../..';
import { useRoute, useBCMSModal } from "@bcm-dev/bcms-vite";

/**
 * @function UnchangedCardOnFileModal
 * @return {React.Component}
 * @exported true
 * @description The modal that shows when a card on file in unchanged.
 */

export default function UnchangedCardOnFileModal(props){
  const navigate = useRoute();
  const { close } = useBCMSModal();

  const onOKClick = evt => {
    close("UnchangedCardOnFileModal");

    if(props.data) {
      if(props.data.onOKClick) {
        props.data.onOKClick();
      } else {
        navigate("/home/cardonfile/cardonfile");
      }
    }
  }
  

  return(
    <CustomModal className="unchanged-card-on-file-modal" id="UnchangedCardOnFileModal">
      <CustomModalContent>
          <p className="text-center">Your merchant status remains unchanged. You can always come back
          and update the card details for this merchant.</p>
      </CustomModalContent>
      <CustomModalFooter className="button-container">
          <ModalPrimaryButton text="OK" onClick={ onOKClick } />
      </CustomModalFooter>
    </CustomModal>
  );
}